<div style="padding-top: 3rem !important;">
    <section class="position-relative py-5 py-md-6" id="about">
        <div class="container pb-0 pt-0">
            <div class="row align-items-center g-4">
                <div class="col-lg-5 col-md-6">
                    <img src="../../../../assets/images/new-images/about-photo.png" class=" img-fluid" />
                </div>
                <div class="col-lg-7 col-md-6 mt-5 mt-md-0">
                    <div class="ms-lg-5">
                        <h3 class="mb-4 display-6 fw-semibold">Launch Your Career with Kenya’s Most In-Demand Jobs</h3>
                        <p class="text-muted mb-4">
                            <strong>Explore high-demand roles in business, technology, communication, and more. Whether
                                you're just starting out or looking to specialize, there’s a role waiting for you.
                            </strong>
                        </p>
                        <ul class="list-unstyled text-muted">
                            <li class="mb-2 d-flex align-items-center">
                                <i class="bi bi-search text-emerald-600 fs-5 me-2 text-success"></i>
                                Curated roles aligned with market needs
                            </li>
                            <li class="mb-2 d-flex align-items-center">
                                <i class="bi bi-bar-chart text-emerald-600 fs-5 me-2 text-success"></i>
                                Opportunities for professional growth
                            </li>
                            <li class="mb-2 d-flex align-items-center">
                                <i class="bi bi-buildings text-emerald-600 fs-5 me-2 text-success"></i>
                                Roles across top companies and industries
                            </li>

                        </ul>
                        <p>Find your perfect fit — browse jobs &nbsp; <a (click)="ApplyNow()" class="btn-theme btn-sm">Apply Now</a>
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </section>
</div>